module.exports = __webpack_public_path__ + "static/fj-c18b1479986c7a3ba0ac7d51969d5581.svg";